import { useTranslations } from "@jugl-web/utils";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { useMemo } from "react";

export const useBoardTemplatesCategories = () => {
  const { t } = useTranslations();
  const { tasksApi } = useRestApiProvider();
  const { data } = tasksApi.useGetBoardTemplatesQuery({
    params: {
      type: "board",
    },
  });

  const categories = useMemo(() => {
    const keys = Object.keys(data || {});

    return keys;
  }, [data]);

  const subcategories = useMemo(() => {
    const map = new Map();
    const keys = Object.keys(data || {});
    if (!data) {
      return map;
    }
    keys.forEach((key) => {
      map.set(key, data[key]);
    });
    return map;
  }, [data]);

  const translations = {
    "popular-templates": t({
      id: "board-templates-modal.popular-templates",
      defaultMessage: "Popular Templates",
    }),
    core: t({
      id: "board-templates-modal.categories.core-workflows",
      defaultMessage: "Core Workflows",
    }),
    industry: t({
      id: "board-templates-modal.categories.industry-workflows",
      defaultMessage: "Industry Workflows",
    }),
    other: t({
      id: "board-templates-modal.categories.other-workflows",
      defaultMessage: "Other Workflows",
    }),
    "business-operations": t({
      id: "board-templates-modal.categories.business-operations",
      defaultMessage: "Business Operations",
    }),
    "create-design": t({
      id: "board-templates-modal.categories.create-design",
      defaultMessage: "Create Design",
    }),
    "customer-success": t({
      id: "board-templates-modal.categories.customer-success",
      defaultMessage: "Customer Success",
    }),
    "finance-and-accounting": t({
      id: "board-templates-modal.categories.finance-and-accounting",
      defaultMessage: "Finance & Accounting",
    }),
    "governance-risk-and-compliance": t({
      id: "board-templates-modal.categories.governance-risk-and-compliance",
      defaultMessage: "Governance, Risk & Compliance",
    }),
    "human-resources-and-recruitment": t({
      id: "board-templates-modal.categories.human-resources-and-recruitment",
      defaultMessage: "Human Resources & Recruitment",
    }),
    "it-service-management": t({
      id: "board-templates-modal.categories.it-service-management",
      defaultMessage: "IT Service Management",
    }),
    legal: t({
      id: "board-templates-modal.categories.legal",
      defaultMessage: "Legal",
    }),
    logistics: t({
      id: "board-templates-modal.categories.logistics",
      defaultMessage: "Logistics",
    }),
    marketing: t({
      id: "board-templates-modal.categories.marketing",
      defaultMessage: "Marketing",
    }),
    "physical-security": t({
      id: "board-templates-modal.categories.physical-security",
      defaultMessage: "Physical Security",
    }),
    procurement: t({
      id: "board-templates-modal.categories.procurement",
      defaultMessage: "Procurement",
    }),
    "product-management": t({
      id: "board-templates-modal.categories.product-management",
      defaultMessage: "Product Management",
    }),
    "professional-services": t({
      id: "board-templates-modal.categories.professional-services",
      defaultMessage: "Professional Services",
    }),
    "project-management": t({
      id: "board-templates-modal.categories.project-management",
      defaultMessage: "Project Management",
    }),
    sales: t({
      id: "board-templates-modal.categories.sales",
      defaultMessage: "Sales",
    }),
    "security-operations": t({
      id: "board-templates-modal.categories.security-operations",
      defaultMessage: "Security Operations",
    }),
    "software-development": t({
      id: "board-templates-modal.categories.software-development",
      defaultMessage: "Software Development",
    }),
    "banks/credit-unions": t({
      id: "board-templates-modal.categories.banks-credit-unions",
      defaultMessage: "Banks/Credit Unions",
    }),
    churches: t({
      id: "board-templates-modal.categories.churches",
      defaultMessage: "Churches",
    }),
    "clubs-and-associations": t({
      id: "board-templates-modal.categories.clubs-and-associations",
      defaultMessage: "Clubs & Associations",
    }),
    "colleges-and-universities": t({
      id: "board-templates-modal.categories.colleges-and-universities",
      defaultMessage: "Colleges & Universities",
    }),
    construction: t({
      id: "board-templates-modal.categories.construction",
      defaultMessage: "Construction",
    }),
    nonprofits: t({
      id: "board-templates-modal.categories.nonprofits",
      defaultMessage: "Nonprofits",
    }),
    "real-estate": t({
      id: "board-templates-modal.categories.real-estate",
      defaultMessage: "Real Estate",
    }),
    "restaurants-and-food-service": t({
      id: "board-templates-modal.categories.restaurants-and-food-service",
      defaultMessage: "Restaurants & Food Service",
    }),
    students: t({
      id: "board-templates-modal.categories.students",
      defaultMessage: "Students",
    }),
    teachers: t({
      id: "board-templates-modal.categories.teachers",
      defaultMessage: "Teachers",
    }),
    "venture-capital": t({
      id: "board-templates-modal.categories.venture-capital",
      defaultMessage: "Venture Capital",
    }),
    "business-continuity-planning": t({
      id: "board-templates-modal.categories.business-continuity-planning",
      defaultMessage: "Business Continuity Planning",
    }),
    "business-strategy": t({
      id: "board-templates-modal.categories.business-strategy",
      defaultMessage: "Business Strategy",
    }),
    "event-planning": t({
      id: "board-templates-modal.categories.event-planning",
      defaultMessage: "Event Planning",
    }),
    "facility-management": t({
      id: "board-templates-modal.categories.facility-management",
      defaultMessage: "Facility Management",
    }),
    "giving-back": t({
      id: "board-templates-modal.categories.giving-back",
      defaultMessage: "Giving Back",
    }),
    "health-and-wellness": t({
      id: "board-templates-modal.categories.health-and-wellness",
      defaultMessage: "Health & Wellness",
    }),
    "personal-productivity": t({
      id: "board-templates-modal.categories.personal-productivity",
      defaultMessage: "Personal Productivity",
    }),
    "political-campaigns": t({
      id: "board-templates-modal.categories.political-campaigns",
      defaultMessage: "Political Campaigns",
    }),
    "quality-assurance": t({
      id: "board-templates-modal.categories.quality-assurance",
      defaultMessage: "Quality Assurance",
    }),
    "remote-work": t({
      id: "board-templates-modal.categories.remote-work",
      defaultMessage: "Remote Work",
    }),
    startups: t({
      id: "board-templates-modal.categories.startups",
      defaultMessage: "Startups",
    }),
  };

  return {
    translations,
    categories,
    subcategories,
  };
};
